function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/user/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const UserRoutes = [
  {
    path: '/user/dashboard',
    component: view('Dashboard'),
    name: 'user.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/repairs/pending',
    component: view('Pending'),
    name: 'user.repairs.pending',
    meta: {
      breadcrumb: [
        {
          text: 'Repairs And Maintenace Requests'
        },
        {
          text: 'Pending',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/repairs/histories/:status?',
    component: view('Histories'),
    name: 'user.repairs.histories',
    meta: {
      breadcrumb: [
        {
          text: 'Repairs And Maintenace Requests'
        },
        {
          text: 'Histories',
          active: true
        }
      ]
    }
  }
]

export default UserRoutes
